import React from "react";

import { Box, Button, Center, Heading, Text, VStack } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";

/**
 * Catches every path the router does not know. Without it an unknown URL —
 * /channels/instagram was one — matched no route and rendered nothing, which
 * looks exactly like a broken page.
 */
const NotFound = () => {
  const location = useLocation();

  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center">
      <Center>
        <VStack spacing={4} maxW="lg" px={4} textAlign="center">
          <Heading size="2xl">404</Heading>
          <Heading size="md">This page does not exist</Heading>
          <Text color="gray.500" fontSize="sm">
            Nothing is served at {location.pathname}.
          </Text>
          <Button onClick={() => (window.location.href = "/")}>
            Go to the portal
          </Button>
        </VStack>
      </Center>
    </Box>
  );
};

export default NotFound;
